const { mostraAlertaError } = require("../alerts/sweetAlert");

exports.ErroresPeticion = (error) => {
    console.error(error);

    if (!error.response) {
        return mostraAlertaError(
            "Error de conexión. Verifique la red o el servidor."
        );
    }

    const { status, data } = error.response;

    const mensaje =
        data?.error ||
        data?.message ||
        data?.mensaje ||
        "Ha ocurrido un error.";

    if (status === 400 && Array.isArray(data)) {
        return mostraAlertaError(
            data.map(e => e.msg).join("\n")
        );
    }

    mostraAlertaError(`(${status}) ${mensaje}`);
};